import { Injectable } from '@angular/core';
@Injectable()
export class HostService {
  // host = "https://api.helpyfood.com/api/website/"
  // host2 = "https://api.helpyfood.com"

  
  // host = "https://api.restocall.com/api/website2/"
  // host2 = "https://api.restocall.com"

  host = "https://api.helpyfood.com/api/website2/"
  host2 = "https://api.helpyfood.com"

  constructor() {}
}


